import { RefObject, useEffect } from 'react';

function useCssProp(
  ref: RefObject<HTMLElement>,
  cssPropName: string,
  cssValue?: string
) {
  useEffect(() => {
    if (!ref.current || !cssValue) return;
    ref.current.style.setProperty(cssPropName, cssValue);
  }, [cssPropName, cssValue, ref]);
}

export default useCssProp;
